import { UserModel } from "../../context_providers/auth/user_model";
import { fetchGet, fetchPost, fetchPut, toQueryString } from "../api_client";

// ${process.env.REACT_APP_BACKEND_BASE_URL}

export const GetEmps = async (option: {
  count?: number;
  page?: number;
  search?: string;
  all?: boolean;
  active?: boolean;
  sub_dep?: string;
}) => {
  try {
    let url = `${
      process.env.REACT_APP_BACKEND_BASE_URL
    }/api/v3/employees${toQueryString(option)}`;

    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const GetEmployeesByDept = async (dept: string, subDept: string) => {
  try {
    let url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/all/department/${dept}?all=true&sort=created_at&sort_order=1`;

    if (subDept) {
      url += `&sub_dep=${subDept}`;
    }
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const GetReportingManager = async () => {
  try {
    let url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/reporting-manager`;

    const res = await fetchGet(url);
    let executives: {
      id: number;
      name: string;
      dep: string;
      sub_dep: string;
    }[] = [];
    if (res.success) {
      executives = res.data.map((emp: UserModel) => {
        return {
          id: emp.uid,
          name: `${emp.first_name} ${emp.last_name}`,
          dep: emp.emp_profile?.department,
          sub_dep: emp.emp_profile?.sub_dep,
        };
      });
    }
    return { success: true, data: executives };
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const GetHod = async () => {
  try {
    let url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/hod`;

    const res = await fetchGet(url);
    let executives: {
      id: number;
      name: string;
      dep: string;
      sub_dep: string;
    }[] = [];
    if (res.success) {
      executives = res.data.map((emp: UserModel) => {
        return {
          id: emp.uid,
          name: `${emp.first_name} ${emp.last_name}`,
          dep: emp.emp_profile?.department,
          sub_dep: emp.emp_profile?.sub_dep,
        };
      });
    }
    return { success: true, data: executives };
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const GetEmpDetails = async (uid: any) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/${uid}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const CreateEmpRepo = async (data: UserModel) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees`;
    const res = await fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const UpdateEmpDetails = async (data: UserModel) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/${data.uid}`;
    const res = await fetchPut(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const UpdateEmpStatusRepo = async (data: {
  uid: number;
  active: boolean;
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/${data.uid}/active`;
    const res = await fetchPut(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const InviteUsers = async (data: {
  emails: string[];
  roles: number[];
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/auth/invite-emp`;
    const res = await fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const ResetPassword = async (uid: any) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/reset-password`;
    const res = await fetchPost(url, { uid });

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetDepartments = async () => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/departments`;
    const res = await fetchGet(url);

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetSubDepartmentsByDepartment = async (dept: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/departments/${dept}`;
    const res = await fetchGet(url);

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ImportEmpRepo = async (data: FormData) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/import`;
    const res = await fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};


export const GetUsersByRoleAndDepartment = async (
  roles: string[], 
  department?: string, 
  subDepartment?: string,
  page: number = 1,
  limit: number = 10,
  search?:string
) => {
  try {
    if (!roles || roles.length === 0) {
      return { 
        success: true, 
        data: [],
        pagination: {
          currentPage: 1,
          totalPages: 0,
          totalCount: 0,
          hasNextPage: false,
          hasPrevPage: false
        }
      };
    }
    
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/get-users-by-role`;
    const body = {
      roleIds: roles,
      department: department,
      sub_department: subDepartment,
      page: page,
      limit: limit,
      search: search
    };
    const res = await fetchPost(url, body);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const DeleteRolesByUser = async(
  email_id: string,
  role_ids: string[]
) => {
  try {
    if (!email_id || !role_ids || role_ids.length === 0) {
      return { success: false, error: "Email ID and role IDs are required" };
    }

    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/employees/delete-roles-by-user`;

    const body = {
      email: email_id,
      roleIds: role_ids
    }
    const res = await fetchPost(url, body);
    return res;
  }catch (error: any) {
    return { success: false, error: error.message };
  }
}